<script setup lang="ts">
import { ref, computed } from "vue";
import { useForm } from "vee-validate";
import { useErrors } from "@/utils/api-functions";
//@ts-ignore
import FormInput from "@/components/form/input.vue";
//@ts-ignore
import FormCheckbox from "@/components/form/checkbox.vue";
//@ts-ignore
import FormRadio from "@/components/form/radio.vue";
//@ts-ignore
import FormCombobox from "@/components/form/combobox.vue";
//@ts-ignore
import Submit from "@/components/form/submit.vue";
import * as Yup from "yup";
import { nl } from "yup-locales";
import { useApiStore } from "@/stores/api";

const props = withDefaults(defineProps<{ groups: any; tags: any; viewingDaysLabel: string; viewingDays: any; mailchimpIds: string[]; mailchimpGroupId: string; pageTitle: string }>(), {
    viewingDaysLabel: "Kijkdagen",
    viewingDays: () => [],
    groups: () => [],
    mailchimpIds: () => [],
    tags: "",
    mailchimpGroupId: "subscribers",
});

const apiErrors = useErrors();
const apiStore = useApiStore();

const success = ref(false);
const loading = ref(false);
const component = ref<HTMLDivElement>();

Yup.setLocale(nl);

const { handleSubmit, isSubmitting } = useForm({
    initialValues: {
        first_name: "",
        email: "",
        phone: "",
        viewing_days: [],
        terms: undefined,
        page_title: props.pageTitle,
        href: window.location.href,
        pathname: window.location.pathname,
        tags: props.tags,
        mailchimp_group_id: props.mailchimpGroupId,
        mailchimp_ids: props.mailchimpIds,
    },
    validationSchema: Yup.object({
        page_title: Yup.string(),
        first_name: Yup.string().required().label("Naam"),
        email: Yup.string().email().required().label("Email"),
        phone: Yup.string()
            .matches(/(((\+|00)3[12][ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})/, "GSM is ongeldig")
            .required()
            .label("GSM"),
        mailchimp_ids: Yup.array().label("Mailchimp ids"),
        viewing_days: Yup.array().label(`${props.viewingDaysLabel} dagen`),
        tags: Yup.string().label("Tags"),
        terms: Yup.boolean().required("Je dient te bevestigen dat Laud deze gegevens mag gebruiken om je aanvraag te verwerken."),
        href: Yup.string().required(),
        mailchimp_group_id: Yup.string().label("Mailchimp group ids"),
        pathname: Yup.string().required(),
    }),
});

const successMessage = ref('Bedankt! We hebben uw bericht goed ontvangen. We nemen zo snel mogelijk contact met u op.');
const onSubmit = handleSubmit(async (values, { resetForm }) => {
    try {
        loading.value = true;

        let v: any = values as any;

        v.option_values = "";

        if (values.viewing_days && values.viewing_days.length > 0) {
            v.option_values = values.viewing_days.join(", ");
        }

        // @ts-ignore
        const res = await apiStore.submitViewingDays(v);

        // @ts-ignore
        if (window.hasOwnProperty("dataLayer") && dataLayer) {
            // @ts-ignore
            dataLayer.push({
                event: "cf7submission",
                formId: "1953",
                response: [
                    { name: "first_name", value: values.first_name },
                    { name: "email", value: values.email },
                    { name: "phone", value: values.phone },
                    { name: "href", value: window.location.href },
                    { name: "pathname", value: window.location.pathname },
                ],
            });
        }

        success.value = true;

        //@ts-ignore
        successMessage.value = res.message ?? "Bedankt! We hebben uw bericht goed ontvangen. We nemen zo snel mogelijk contact met u op.";

        setTimeout(resetForm, 500);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});
</script>

<template>
    <form id="appointment_form" key="form" v-if="!success" @submit="onSubmit" class="grid">
        <component :is="apiErrors.render()" :data="apiErrors.get()"></component>

        <form-input name="first_name" label-position="left" type="text" label="Naam"></form-input>
        <form-input name="email" label-position="left" type="email" label="Email"></form-input>
        <form-input name="phone" label-position="left" type="text" label="GSM"></form-input>

        <fieldset class="flex flex-col md:flex-row md:gap-[16px] my-[32px]">
            <label class="min-w-[95px] flex-none block text-white text-15 leading-[20px] font-light tracking-[0.09px] mb-15" for="">{{ viewingDaysLabel }}</label>
            <div class="grid gap-[10px]">
                <form-checkbox v-for="(day, index) in viewingDays" :value="day.day" name="viewing_days" :label="day.day"></form-checkbox>
            </div>
        </fieldset>

        <form-checkbox
            :value="false"
            class="mb-[23px] text-[10px] leading-[15px]"
            name="terms"
            label="Ik ga ermee akkoord dat mijn in het contactformulier verstrekte gegevens door LAUD als verantwoordelijke instantie worden verzameld, verwerkt en gebruikt voor het versturen van informatiemateriaal per post en voor het per e-mail beantwoorden van mijn aanvraag."
        ></form-checkbox>

        <div>
            <submit :disabled="success" :loading="isSubmitting || loading">Inschrijven</submit>
        </div>
    </form>

    <div key="success" class="flex items-center justify-center flex-1 w-full text-white" v-else>
        <p class="text-center">{{  successMessage }}</p>
    </div>
</template>
